import { FormGroup, FormLabel, TextField } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { Abordagem, AbordagemPayload } from "src/apis/eezyfamily";
import CrudDialog from "src/pages/Admin/EezyFamily/components/CrudDialog";

type Props = {
  open: boolean;
  editTarget: Abordagem | null;
  onClose: () => void;
  onSaved: () => void;
  onCreate: (p: AbordagemPayload) => Promise<void>;
  onUpdate: (id: number, p: AbordagemPayload) => Promise<void>;
};

const AbordagemModal: FC<Props> = ({
  open,
  editTarget,
  onClose,
  onSaved,
  onCreate,
  onUpdate,
}): JSX.Element => {
  const [approach, setApproach] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setApproach(editTarget?.approach ?? "");
      setError("");
    }
  }, [open, editTarget]);

  const isEdit = editTarget !== null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!approach.trim()) {
      setError("Abordagem é obrigatória.");
      return;
    }
    setLoading(true);
    try {
      if (isEdit) {
        await onUpdate(editTarget.id, { approach });
      } else {
        await onCreate({ approach });
      }
      onSaved();
    } catch (err: any) {
      setError(err?.message ?? "Erro ao salvar.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <CrudDialog
      open={open}
      title={isEdit ? "Editar Abordagem" : "Nova Abordagem"}
      onClose={onClose}
      onSubmit={handleSubmit}
      loading={loading}
      maxWidth="xs"
    >
      {error && (
        <div style={{ color: "red", fontSize: "0.875rem" }}>{error}</div>
      )}
      <FormGroup>
        <FormLabel required>Abordagem</FormLabel>
        <TextField
          value={approach}
          onChange={(e) => setApproach(e.target.value)}
          placeholder="Ex: Terapia Cognitivo-Comportamental"
          autoFocus
        />
      </FormGroup>
    </CrudDialog>
  );
};

export default AbordagemModal;
